import { Ref } from 'react';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { AccordionItem, AccordionItemRef } from '~/shared/components/Accordion';
import { Text } from '../styled';
import { Package } from './Package';

const ProductDescription = ({
    product,
    ref,
}: {
    product?: ShopTypes.ProductQueryProduct;
    ref?: Ref<AccordionItemRef>;
}) => {
    const { translate } = useTranslations();
    const { item, shortDescription, longDescription } = product ?? {};
    const sanitizedShortDescription = sanitizeDescription(shortDescription);
    const sanitizedLongDescription = sanitizeDescription(longDescription);

    if (
        !product?.longDescription &&
        !product?.shortDescription &&
        !product?.item?.packagings?.length
    ) {
        return null;
    }

    return (
        <AccordionItem
            ref={ref}
            id="description"
            includeId
            header={translate('product.description')}
        >
            {sanitizedShortDescription ? <Text>{sanitizedShortDescription}</Text> : null}
            {sanitizedLongDescription ? <Text>{sanitizedLongDescription}</Text> : null}

            {item?.packagings?.length ? (
                <>
                    <Text isTitle paddingTop>
                        {translate('product.packagingAndSurcharges')}
                    </Text>

                    {item?.packagings?.map((pack, index) => (
                        <Package pack={pack} key={`${pack?.itemNumber}${index}`} />
                    ))}
                </>
            ) : null}
        </AccordionItem>
    );
};

export default ProductDescription;

const sanitizeDescription = (input?: string): string | undefined =>
    input?.replaceAll('da:,pl:', '');
